import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewIndex = () => import('./index')

Vue.use(Router)

const router =
  [
    {
      path: '/a/settings',
      component: DefaultContainer,
      children: [
        {
          path: 'configurate',
          name: 'A_Settings',
          component: ViewIndex,
          beforeEnter: Permisos.IS_ADMIN,
          meta: {
            title: 'Configuraciones',
          }                    
        },
      ]
    },
  ]

export default router
